var heading_default = {
  "fontElementMap": "_1a04S",
  "elementSpacing": "Nv75f",
  "headerOne": "LD-Jq Nv75f",
  "headerTwo": "ojTHA Nv75f",
  "headerThree": "lOO9j Nv75f",
  "headerFour": "_0btP8 Nv75f",
  "headerFive": "SaUcA Nv75f",
  "headerSix": "_0iYt4 Nv75f",
  "child": "EUh9L"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
